import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/auth';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

// 恢复登录状态
const auth = useAuthStore();
auth.restoreUser();

app.use(router);
app.mount('#app');
